import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user:    null,
    loading: false,
    _fetchPromise: null,   // singleton — concurrent guards share one fetch
  }),

  getters: {
    isLoggedIn: (state) => !!state.user,
    userEmail:  (state) => state.user?.email || '',
  },

  actions: {
    fetchMe() {
      // If a fetch is already in flight, return the same promise so multiple
      // router-guard invocations all wait for the same request instead of
      // skipping it and seeing user=null.
      if (this._fetchPromise) return this._fetchPromise

      this.loading = true
      this._fetchPromise = axios.get('/auth/get_current_user')
        .then(res  => { this.user = res.data })
        .catch(()  => { this.user = null })
        .finally(() => { this.loading = false; this._fetchPromise = null })

      return this._fetchPromise
    },

    async login(email, password) {
      this.loading = true
      try {
        await axios.post('/auth/login', { email, password })
        await this.fetchMe()
      } finally {
        this.loading = false
      }
    },

    async logout() {
      await axios.post('/auth/logout')
      this.user = null
    },
  },
})
